import { Instance } from 'mobx-state-tree';
import React from 'react';
import { Secretariat, SystemStatus } from '../../store/models';
import { Form } from 'react-final-form';
import { toJS } from 'mobx';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import styled from '@emotion/styled';
import { TLCode } from '../../common/enums';
import { TextInputFormField } from '../common/form';
import VerticalForm from '../common/form/VerticalForm';
import SecretariatFormField from '../common/form/SecretariatFormField';
import { Button, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Translate } from '../common/WithTranslate';
import { LIST } from '@blueprintjs/icons/lib/esm/generated/iconNames';

const Container = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  & button {
    margin-left: 5px;
  }
`;

interface SystemStatusFormProps {
  systemStatus?: Instance<typeof SystemStatus>;
  secretariats: Array<Instance<typeof Secretariat>>;
  save: (data: any) => void;
  isSuperAdmin: boolean;
  translate: Translate;
  backToSecretariatList: () => void;
}

export const SystemStatusForm = ({
  systemStatus,
  secretariats,
  save,
  isSuperAdmin,
  translate,
  backToSecretariatList,
}: SystemStatusFormProps) => {
  return (
    <Form
      initialValues={toJS(systemStatus) || {}}
      onSubmit={save}
      render={({ handleSubmit, dirty, form, hasValidationErrors }) => (
        <form onSubmit={handleSubmit}>
          <LeaveRouteDirtyWrapper blockChange={dirty} />
          <Container>
            <VerticalForm labelWidth={175}>
              <TextInputFormField
                name="subSystem"
                label={TLCode.SYSTEM_STATUS_SystemStatusName}
                inline={true}
                fill={true}
                required={true}
                disabled={systemStatus !== undefined}
              />
              <TextInputFormField
                name="status"
                label={TLCode.SYSTEM_STATUS_SystemStatusValue}
                inline={true}
                fill={true}
                required={true}
                disabled={!isSuperAdmin}
              />
              <TextInputFormField
                name="year"
                label={TLCode.SYSTEM_STATUS_SystemStatusYear}
                inline={true}
                fill={true}
                required={true}
                disabled={!isSuperAdmin}
              />
              <SecretariatFormField
                label={TLCode.SECRETARIAT}
                name="secretariatId"
                secretariatList={secretariats}
                disabled={!isSuperAdmin}
              />
            </VerticalForm>
            <ButtonsContainer>
              <Button icon={LIST} onClick={backToSecretariatList} text={translate(TLCode.BackToList)} />
              <Button
                text={translate(TLCode.GENERAL_Cancel)}
                icon={IconNames.ERASER}
                intent={Intent.PRIMARY}
                onClick={() => form.reset()}
                disabled={!dirty}
              />
              <Button
                type={'submit'}
                text={translate(TLCode.GENERAL_Save)}
                icon={IconNames.FLOPPY_DISK}
                intent={Intent.PRIMARY}
                disabled={hasValidationErrors || !dirty}
              />
            </ButtonsContainer>
          </Container>
        </form>
      )}
    />
  );
};
